// extracted by mini-css-extract-plugin
export default {"articleFooter":"articleFooter--2MwGd","separator":"separator--1328J"};